export const faqs = [
  {
    category: "Academics",
    question: "How many Physics electives are required for BS-MS Physics?",
    keywords: ["electives", "bsms", "bs", "credits", "courses"],
    answerText:
      "For BS-MS Physics, you need 6 Physics electives out of 10 open electives.\n\nFor BS exit, you need 4 Physics electives out of 6 open electives.",
  },

  {
    category: "Research",
    question: "Can I do MS thesis outside IISER Bhopal?",
    keywords: ["thesis", "outside", "external", "iiserb", "ms"],
    answerText:
      "Yes, but only under specific conditions.\n\nRequirements:\n- Must be under IISERB faculty collaboration\n- External institute must have MoU or research tie\n- Requires department and institute approval\n\nIndependent external thesis without IISERB link is NOT allowed.\n\nView circular: /docs/ms-thesis-outside.pdf",
  },

  {
    category: "Research",
    question: "How do I apply for MS thesis outside IISERB?",
    answerText:
      "Typical process:\n- Find a supervisor at IISERB\n- Identify collaborating external lab\n- Get approval from your supervisor\n- Submit request to department\n\nStart early in 5th year to avoid delays.",
  },

  {
    category: "Minor",
    question: "What is the Quantum Technologies minor?",
    keywords: ["qt", "quantum", "minor", "definition"],
    answerText:
      "A minor focused on quantum computing, quantum information, and quantum materials. It is open to BS-MS, BS, and BTech students.",
  },

  {
    category: "Minor",
    question: "What are the credit requirements for QT minor?",
    keywords: ["credit", "credits", "qt", "minor", "requirement"],
    answerText:
      "You need 18 credits.\n\nRules:\n- No double counting with major\n- Same course cannot count for multiple minors",
  },

  {
    category: "Minor",
    question: "Which courses are required for Quantum Technologies minor?",
    answerText:
      "Core courses:\n- PHY303: Quantum Mechanics I\n- One of:\n  - PHY425/625: Quantum Information Theory\n  - ECS417/617: Intro to Quantum Computer Science\n- ECS326/676: Digital Circuits\n- One of:\n  - ECS327: EECS Lab I\n  - ECS330: EECS Lab II",
  },

  {
    category: "Minor",
    question: "Which electives can be used for QT minor?",
    answerText:
      "You can choose from:\n- Condensed Matter Physics\n- Decoherence and Open Quantum Systems\n- Classical and Quantum Optics\n- Quantum Engineering\n- Magnetism and Superconductivity\n- Ultrafast Optics",
  },

  {
    category: "Minor",
    question: "Can I use the same course for major and QT minor?",
    answerText:
      "No. Courses counted toward your major cannot be used for the minor.",
  },

  {
    category: "Minor",
    question: "Where can I find Quantum Technologies minor rules?",
    answerText:
      "View official circular: /docs/qt-minor.pdf",
  }
];
